import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=a6ddf684&scoped=true&"
import script from "./Issues.vue?vue&type=script&lang=js&"
export * from "./Issues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ddf684",
  null
  
)

export default component.exports